const windoweditsteps = {
    stepsENG: [
      {
        target: '.v-step-0',
        content: 'Enter a name or description for the window.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-1',
        content: `Click to change the opening direction (left/right).`,
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-2',
        content: 'Click to change the packaging (set/bulk).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-3',
        content: 'Click to change the groove (14-18/10-14).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-4',
        content: 'Enter the number of identical windows.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-5',
        content: 'Select the color code.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-6',
        content: 'Select window type.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-7',
        content: 'Select the Chrono hardware type.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-8',
        content: 'Select the hinge type.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-9',
        content: 'Select the handle type.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-10',
        content: 'Click to select an additional handle reinforcement plate (only with fork handles).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-11',
        content: 'Click to select a 90° blocking piece (only with fork handles on side- or bottom-hung windows).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-12',
        content: 'Click to select the required profile (only with open-out windows).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-13',
        content: 'Enter the sash width (in mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-14',
        content: 'Enter the second sash width (in mm) (only french casement windows).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-15',
        content: 'Enter the sash height (in mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-16',
        content: 'After leaving the sash height field, the handle height is calculated on half of the height. Enter the handle height (in mm) to change it.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-17',
        content: 'Enter the sash weight (in kg).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-18',
        content: 'Enter the second sash weight (in kg) (only french casement windows).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-19',
        content: 'Click to select an optional night vent device.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-20',
        content: 'Click to select an optional magnetic contact.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-21',
        content: 'Click to select an optional window stay.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-22',
        content: 'Click to select an optional snapper.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-23',
        content: 'Select the bolt screw length (only french casement windows).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-24',
        content: 'Enter the profile depth for the central locking (only french casement windows).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-25',
        content: 'Click to force a central locking device (only french casement windows)',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-26',
        content: 'Click to select adjustable bolt keeps (only french casement windows).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-27',
        content: 'Click to send the configuration to the server. If the parameters are valid, the window is saved and the application returns to the window list. In case of validation errors, clues will be visible under the incorrect parameter(s)',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-28',
        content: 'Click to cancel. The parameters are not saved and the application returns to the window list.',
        params: {
          placement: 'bottom'
        }
      },
    ],
    stepsNED: [
      {
        target: '.v-step-0',
        content: 'Vul een naam of omschrijving in.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-1',
        content: `Klik om de openingsrichting te wijzigen (links/rechts).`,
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-2',
        content: 'Klik om de verpakking te wijzigen (set/grootverpakking).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-3',
        content: 'Klik om de groef te wijzigen (14-18/10-14).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-4',
        content: 'Vul het aantal identieke ramen in.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-5',
        content: 'Selecteer de kleurcode.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-6',
        content: 'Selecteer het raamtype.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-7',
        content: 'Selecteer het Chrono beslagtype.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-8',
        content: 'Selecteer het scharniertype.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-9',
        content: 'Selecteer het kruktype.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-10',
        content: 'Klik om een bijkomende versterkingsrib te voorzien (enkel bij krukken met vork).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-11',
        content: 'Klik om een 90° blokkeerplaat te voorzien (enkel bij krukken met vork op val- en draairamen).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-12',
        content: 'Klik om een profielreeks te selecteren (enkel bij buitendraaiende ramen).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-13',
        content: 'Vul de vleugelbreedte in (mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-14',
        content: 'Vul de vleugelbreedte van de tweede vleugel in (mm) (enkel bij stolpramen).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-15',
        content: 'Vul de vleugelhoogte in (mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-16',
        content: 'Bij het verlaten van het veld vleugelhoogte wordt de kruk op de helft van de hoogte geplaatst. Vul indien nodig een andere krukhoogte in (mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-17',
        content: 'Vul het vleugelgewicht in (kg).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-18',
        content: 'Vul het vleugelgewicht van de tweede vleugel in (kg) (enkel bij stolpramen).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-19',
        content: 'Klik om een optionele kierstand te voorzien.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-20',
        content: 'Klik om een optioneel magneetcontact te voorzien.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-21',
        content: 'Klik om een optionele raambegrenzer te voorzien.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-22',
        content: 'Klik om een optionele snapper te voorzien.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-23',
        content: 'Selecteer de lengte van de stolpgrendelschroeven (enkel bij stolpramen).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-24',
        content: 'Vul de profieldiepte van de makelaar in (enkel bij stolpramen).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-25',
        content: 'Klik om een centrale vergrendeling ipv stolpgrendels te voorzien. (enkel bij stolpramen)',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-26',
        content: 'Klik om regelbare sluitstukken te voorzien (enkel bij stolpramen met grendels).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-27',
        content: 'Klik om de configuratie naar de server te verzenden. Als alle parameters correct zijn wordt het raam opgeslaan en de applicatie keert terug naar de ramenlijst. Validatiefouten worden getoond onder de desbetreffende parameter.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-28',
        content: 'Klik om te annuleren. De parameters worden niet opgeslaan en de applicatie keert terug naar de ramenlijst.',
        params: {
          placement: 'bottom'
        }
      },
    ],
    stepsCHI: [
      {
        target: '.v-step-0',
        content: '输入窗型编号或描述',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-1',
        content: `单击此按钮切换开启方向（左/右）`,
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-2',
        content: '单击此按钮切换包装方式（套件/散件大包装）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-3',
        content: '单击此按钮切换五金槽口形式（14-18槽/10-14槽）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-4',
        content: '输入窗型数量',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-5',
        content: '选择颜色编号',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-6',
        content: '选择开启类型',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-7',
        content: '选择Chrono锁闭类型',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-8',
        content: '选择铰链类型',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-9',
        content: '选择执手类型',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-10',
        content: '单击选择增加执手加强背板（只适用于拨叉执手）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-11',
        content: '单击选择90°限位块（只适用于拨叉执手做平开窗或内倒窗）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-12',
        content: '单击选择适用的型材（只适用于外开窗）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-13',
        content: '输入窗扇宽度（mm）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-14',
        content: '输入被动扇宽度（mm）（仅限对开窗）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-15',
        content: '输入窗扇高度（mm）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-16',
        content: '输入窗扇高度后，执手高度是默认居中的。可输入执手高度（mm）调整为所需要的实际尺寸',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-17',
        content: '输入窗扇重量（kg）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-18',
        content: '输入被动扇重量（kg）（仅限对开窗）',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-19',
        content: '单击选择增加夜晚微通风',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-20',
        content: '单击选择增加电磁锁座',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-21',
        content: '单击选择增加限位风撑',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-22',
        content: '单击选择增加碰扣门吸',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-23',
        content: '选择固定插销的螺钉长度（仅限对开窗）',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-24',
        content: '输入假中梃型材的深度用于选择联动插销（仅限对开窗）',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-25',
        content: '单击选择联动插销（仅限对开窗）',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-26',
        content: '单击选择可调插销锁座（仅限对开窗）',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-27',
        content: '单击提交后，配置参数发送到服务器。如果所有参数有效，窗型将被保存，并返回到窗型列表。当配置参数有误时，不正确的参数信息将显示在下方。',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-28',
        content: '单击将取消。窗型参数不保存，并返回到窗型列表',
        params: {
          placement: 'bottom'
        }
      },
    ],
    stepsPOR: [
      {
        target: '.v-step-0',
        content: 'Insira o nome ou descrição da janela.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-1',
        content: `Carregue para alterar a orientação de abertura da janela (esquerdo/direito).`,
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-2',
        content: 'Carregue para alterar o formato de embalagem (kit/formato industrial).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-3',
        content: 'Carregue para alterar o canal do perfil (14-18/10-15).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-4',
        content: 'Introduza o numero de janelas idênticas.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-5',
        content: 'Selecione o código da cor.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-6',
        content: 'Selecione o tipo de janela.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-7',
        content: 'Selecione o tipo de Sistema Chrono.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-8',
        content: 'Selecione o tipo de dobradiça.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-9',
        content: 'Selecione o tipo de puxador.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-10',
        content: 'Carregue para selecionar o calço de reforço para o cremone (apenas puxadores de garfo).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-11',
        content: 'Carregue para selecionar a peça de bloqueio a 90º (apenas puxadores de garfo e em sistemas projetantes cremone horizontal e batente).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-12',
        content: 'Carregue para selecionar o tipo de perfil. (apenas para janelas de batente de abertura para o exterior).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-13',
        content: 'Introduza a largura da folha móvel (em mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-14',
        content: 'Introduza a largura da segunda folha (em mm) (apenas para janelas de duas folhas).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-15',
        content: 'Introduza a altura da folha móvel (em mm).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-16',
        content: 'Após introduzir a altura da folha móvel, a altura do puxador é calculada por defeito a metade da altura total. Introduza a altura do puxador (em mm) caso pretenda alterar a medida.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-17',
        content: 'Introduza o peso da folha móvel (em kg).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-18',
        content: 'Introduza o peso da segunda folha (em kg) (apenas para janelas de duas folhas).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-19',
        content: 'Carregue para selecionar a opção de microventilação.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-20',
        content: 'Carregue para selecionar a opção de contacto magnético.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-21',
        content: 'Carregue para selecionar a opção limitador de abertura.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-22',
        content: 'Carregue para selecionar a opção Clip.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-23',
        content: 'Selecione o comprimento dos parafusos (apenas para janelas de duas folhas).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-24',
        content: 'Introduza a profundidade do perfil, onde o fecho de segunda folha irá ser usado (apenas para janelas de duas folhas).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-25',
        content: 'Carregue para utilizar um fecho central de segunda folha (apenas para janelas de duas folhas).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-26',
        content: 'Carregue para selecionar pontos de fecho ajustáveis (apenas para janelas de duas folhas).',
        params: {
          placement: 'top'
        }
      },
      {
        target: '.v-step-27',
        content: 'Carregue para enviar a configuração para o servidor. Se os parametros introduzidos forem válidos, a janela é gravada e a aplicação voltará à listagem de janelas. Caso ocorram erros de validação, surgirão dicas por baixo do(s) campo(s) com erro(s).',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.v-step-28',
        content: 'Carregue para cancelar. Os parametros não foram gravados e a aplicação voltará à listagem de janelas.',
        params: {
          placement: 'bottom'
        }
      },
    ],
    }

    export default windoweditsteps


// WEBPACK FOOTER //
// ./src/ClientApp/helpers/windowedit-steps.js